import { SERA } from './sera';

export const MESSAGE_CHANNELS = {
  whatsapp: { id: 'whatsapp', label: 'WhatsApp', short: 'WA' },
  sms: { id: 'sms', label: 'SMS', short: 'SMS' },
  email: { id: 'email', label: 'Email', short: 'Email' },
};

export const MOCK_THREADS = [
  {
    id: 't1',
    clientName: 'Adaobi Nwosu',
    clientInitials: 'AN',
    channel: 'whatsapp',
    unread: true,
    lastAt: '2 min ago',
    preview: 'Do you have knotless braids availability on Saturday?',
    phone: '+234 803 441 2290',
    context: {
      lastVisit: '6 weeks ago · Silk press',
      preference: 'Prefers Amara · afternoon slots',
      notes: 'Sensitive scalp — avoid strong heat.',
    },
    messages: [
      {
        id: 't1m1',
        from: 'client',
        at: '10:41',
        text: 'Hi! Do you have knotless braids availability on Saturday?',
      },
      {
        id: 't1m2',
        from: 'client',
        at: '10:42',
        text: 'Preferably morning or early afternoon if possible 🙏',
      },
    ],
    seraDraft: {
      status: 'ready',
      confidence: 'high',
      usedContext: [
        'Service: Knotless braids · 3 hr 30 min · ₦45,000',
        'Saturday: Amara free from 11:00',
        'Client last visit: silk press 6 weeks ago',
      ],
      text: 'Hi Adaobi — yes, we can do knotless braids on Saturday. Amara has an opening from 11am (about 3.5 hours). It\u2019s ₦45,000. Shall I hold that for you?',
    },
  },
  {
    id: 't2',
    clientName: 'Chioma Okeke',
    clientInitials: 'CO',
    channel: 'whatsapp',
    unread: true,
    lastAt: '18 min ago',
    preview: 'Can I move my 2pm tomorrow to later?',
    phone: '+234 809 112 8841',
    context: {
      lastVisit: 'Tomorrow · Silk press (confirmed)',
      preference: 'Often reschedules · still loyal',
      notes: 'Deposit paid online ₦5,000',
    },
    messages: [
      {
        id: 't2m1',
        from: 'business',
        at: 'Yesterday',
        text: 'Reminder: silk press tomorrow at 2:00pm with Zainab. Reply YES to confirm.',
        via: SERA.name,
      },
      {
        id: 't2m2',
        from: 'client',
        at: '10:24',
        text: 'Can I move my 2pm tomorrow to later? Something came up at work.',
      },
    ],
    seraDraft: {
      status: 'ready',
      confidence: 'high',
      usedContext: [
        'Booking: Silk press tomorrow 14:00 · Zainab',
        'Later slots free: 16:00 and 17:30',
        'Deposit ₦5,000 already paid',
      ],
      text: 'Of course Chioma — Zainab still has 4pm and 5:30pm tomorrow. Your deposit stays on the booking. Which time works better?',
    },
  },
  {
    id: 't3',
    clientName: 'Tunde Adebayo',
    clientInitials: 'TA',
    channel: 'sms',
    unread: false,
    lastAt: '1 hr ago',
    preview: 'YES',
    phone: '+234 701 553 0192',
    context: {
      lastVisit: 'Tomorrow · Consultation',
      preference: 'SMS only',
      notes: 'New client from Instagram',
    },
    messages: [
      {
        id: 't3m1',
        from: 'business',
        at: '09:02',
        text: 'Spirara: Reminder — consultation tomorrow 11:00am. Reply YES to confirm or CALL to reschedule.',
        via: SERA.name,
      },
      {
        id: 't3m2',
        from: 'client',
        at: '09:40',
        text: 'YES',
      },
    ],
    seraDraft: {
      status: 'idle',
      confidence: null,
      usedContext: [],
      text: '',
    },
  },
  {
    id: 't4',
    clientName: 'Amara Benson',
    clientInitials: 'AB',
    channel: 'email',
    unread: false,
    lastAt: 'Yesterday',
    preview: 'Receipt for Saturday\u2019s visit and gift voucher enquiry',
    phone: 'amara.b@email.com',
    context: {
      lastVisit: 'Saturday · Deep tissue + add-on',
      preference: 'Email receipts',
      notes: 'Asked about corporate vouchers',
    },
    messages: [
      {
        id: 't4m1',
        from: 'client',
        at: 'Yesterday 16:20',
        text: 'Thanks for Saturday — could you resend the receipt? Also, do you sell gift vouchers for the team at my office?',
      },
      {
        id: 't4m2',
        from: 'business',
        at: 'Yesterday 17:05',
        text: 'Receipt attached for ₦18,500. Yes — we offer gift vouchers from ₦10,000. I can set up a corporate pack if you share how many you need.',
        via: SERA.name,
      },
    ],
    seraDraft: {
      status: 'sent',
      confidence: 'high',
      usedContext: ['Completed visit Saturday · ₦18,500', 'Vouchers from ₦10,000'],
      text: '',
    },
  },
  {
    id: 't5',
    clientName: 'Ngozi Eze',
    clientInitials: 'NE',
    channel: 'whatsapp',
    unread: false,
    lastAt: '2 days ago',
    preview: 'Perfect, see you Thursday!',
    phone: '+234 812 990 4410',
    context: {
      lastVisit: 'Thu · Scalp treatment',
      preference: 'WhatsApp confirmations',
      notes: '',
    },
    messages: [
      {
        id: 't5m1',
        from: 'business',
        at: '2 days ago',
        text: 'Hi Ngozi — confirming your scalp treatment Thursday at 1pm with Amara.',
        via: 'Front desk',
      },
      {
        id: 't5m2',
        from: 'client',
        at: '2 days ago',
        text: 'Perfect, see you Thursday!',
      },
    ],
    seraDraft: {
      status: 'idle',
      confidence: null,
      usedContext: [],
      text: '',
    },
  },
];

export const MOCK_TEMPLATES = [
  {
    id: 'tpl1',
    name: 'Appointment confirmation',
    channel: 'WhatsApp / SMS',
    body: 'Hi {{client_name}} — confirming your {{service}} on {{date}} at {{time}} with {{staff}}. Reply YES to confirm.',
  },
  {
    id: 'tpl2',
    name: 'Day-before reminder',
    channel: 'WhatsApp / SMS',
    body: 'Reminder: {{service}} tomorrow at {{time}}. We\u2019re at {{location}}. Need to reschedule? Just reply here.',
  },
  {
    id: 'tpl3',
    name: 'Deposit request',
    channel: 'WhatsApp',
    body: 'To hold your {{service}} on {{date}}, please pay a ₦{{deposit}} deposit here: {{payment_link}}',
  },
  {
    id: 'tpl4',
    name: 'Thank you + rebook',
    channel: 'Email',
    body: 'Thanks for visiting {{business}}! Your next {{service}} is typically due in {{weeks}} weeks — book here: {{booking_link}}',
  },
];

export const MOCK_REMINDERS = [
  {
    id: 'r1',
    name: 'Day-before confirmation',
    trigger: '24 hours before appointment',
    channels: ['WhatsApp', 'SMS'],
    active: true,
    sentLast7d: 42,
  },
  {
    id: 'r2',
    name: 'Same-day nudge',
    trigger: '3 hours before appointment',
    channels: ['WhatsApp'],
    active: true,
    sentLast7d: 38,
  },
  {
    id: 'r3',
    name: 'No-show follow-up',
    trigger: '1 hour after missed appointment',
    channels: ['SMS'],
    active: false,
    sentLast7d: 0,
  },
  {
    id: 'r4',
    name: 'Rebook after visit',
    trigger: '3 days after completed visit',
    channels: ['WhatsApp', 'Email'],
    active: true,
    sentLast7d: 19,
  },
];
